import React from "react";
import { observer } from "mobx-react-lite";

import {BalanceRequestModal, CheckTicketModal, EditBalanceLimitModal} from "../../components/modals";
import { JackpotModal } from "../../components/modals/jackpot";
import { useStore } from "../../../hooks";

interface GlobalModalsProps {}

export const GlobalModals: React.FC<GlobalModalsProps> = observer(() => {
  const {
    modalStore: {
      isOpenBalanceAndLimitModal,
      checkModal: { open: checkModalOpen },
      jackpotModal: { open: jackpotModalOpen },
      balanceRequestModal: { open: balanceRequestModal },
    },
  } = useStore();

  return (
    <>
      {isOpenBalanceAndLimitModal && <EditBalanceLimitModal />}
      {checkModalOpen && <CheckTicketModal />}
      {jackpotModalOpen && <JackpotModal />}
      {balanceRequestModal && <BalanceRequestModal />}
    </>
  );
});
